import React, {useState, useEffect} from 'react';
import { RouteKey } from '../../config/page-key';
import {
	BellFilled
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { Menu } from 'antd';
import { useLocation, useHistory } from 'react-router-dom';
import { useCan } from '../../features/user/Can';
import { useUserInfo } from '../../features/user/userApi';
import { FeatureFlag, Role } from '../../features/user/Permission';

const SidebarNavBottom = ({ isMainNavExpanded }) =>{
	const { i18n, t } = useTranslation();
	const history = useHistory();
	const location = useLocation();
	const userInfo = useUserInfo();
	const can = useCan();
	
	const menu = [
		{
			key: RouteKey.SYSTEM_ANNOUNCEMENT, icon: <BellFilled />, label: t('Nav.SystemAnnouncement'), navPosition : 'bottom', everyRole: [Role.SITE_ADMIN, Role.ADMIN]
		}
	]

	const onMenuClick = (e)=>{
		history.push(e.key)
	}

	return (
		<Menu theme="dark"
			selectedKeys={isMainNavExpanded ? menu.filter(i => i.key === location.pathname).map(i => i.key) : []}
			defaultSelectedKeys={[location.pathname]} onClick={onMenuClick} mode="inline" items={menu.filter(menu => can({ ...menu })).map(i => {
				return { key: i.key, icon: i.icon, label: i.label }
			})} />
	);
}

export default SidebarNavBottom;